<template>
  <div styleName="opt_video_wrap_t" v-if="isPlayingVideo===2">
    <BaseVideo :src="currentVideoUrl" :currentTime="currentTime" v-bind:controls="true" v-bind:muted="false" @seeked="seekVideo" @pause="pauseVideo" @play="playVideo" @ended="endVideo" @mounted="initMixVideo" @timeupdate="_timeupdate" @error="error" ref="baseVideo"></BaseVideo>
    <span styleName="closeBtn" @click="_close"></span>
  </div>
</template>
<script>
import styles from './index.scss'
import CSSModules from 'vue-css-modules'
import BaseVideo from './BaseVideo'
import { mapGetters } from 'vuex'
import { signalSdk } from '@/utils/getSDK'
import axios from '@/api/index'
import * as types from '@/constants/index'
const PREPAREPALYINGSTATUS = ['0', '1', '2']
const micVolume = 20
export default {
  mixins: [CSSModules(styles)],
  name: 'TeacherVideo',
  data: function () {
    return {
      videoStatus: '0',
      currentTime: 0,
      currentPlayedTime: 0
    }
  },
  computed: {
    ...mapGetters(['currentVideoUrl', 'isPlayingVideo']),
  },
  watch: {
    currentVideoUrl (newUrl) {
      if (!newUrl) {
        if (this.syncVideoTimer) {
          clearInterval(this.syncVideoTimer)
          this.syncVideoTimer = null
        }
      }
    }
  },
  mounted () {
    signalSdk.on('INIT_VIDEO_MP4', (data) => {
      console.log('监听201', data)
      let { progress_bar, status, url } = data
      if (PREPAREPALYINGSTATUS.includes(status)) {
        this.videoStatus = status
        setTimeout(() => {
          this.currentTime = JSON.parse(progress_bar)
        }, 0)
        console.log('status',status==='3')
        console.log('status',status)
        if(status==='3'|| (status==='0' && url==='')){
          this.$store.commit(types.SET_VIDEO_STATUS, 1)
        }else{
          this.$store.commit(types.SET_VIDEO_STATUS, 2)
        }
        this.$store.commit(types.SET_VIDEO_URL, url)
        // 浏览器策略导致无法自动播放
      }
    })

    window.addEventListener('beforeunload', () => {
      this.getGMTTimestamp().then((time) => {
        if (this.isPlayingVideo===2) {
          signalSdk.sendPauseVideoMP4({
            url: this.currentVideoUrl,
            progress_bar: JSON.stringify(this.currentPlayedTime),
            seek_timestamp: JSON.stringify(time)
          })
        }
      })
    })
  },
  methods: {
    seekVideo (e) {
      this.getGMTTimestamp().then((time) => {
        signalSdk.sendSeekVideoMP4({
          url: this.currentVideoUrl,
          status: this.videoStatus,
          progress_bar: JSON.stringify(this.currentPlayedTime),
          seek_timestamp: JSON.stringify(time)
        }).catch((e) => {
          this.$toast.show({
            header: false,
            text: this.$t('operationFailuer'),
            textStyle: {
              'text-align': 'center'
            },
            btnText: this.$t('refresh'),
            btnOK: () => {
              location.reload()
            }
          })
        })
      })
    },
    playVideo (e) {
      this.$audioMixing.setMicroVolume(micVolume) // 视频开始播放后降低麦克风音量
      this.getGMTTimestamp().then((time) => {
        signalSdk.sendPlayVideoMP4({
          url: this.currentVideoUrl,
          progress_bar: JSON.stringify(this.currentPlayedTime),
          seek_timestamp: JSON.stringify(time)
        }).then(() => {
          this.syncVideo()
          this.videoStatus = '1'
        }).catch((e) => {
          this.$toast.show({
            header: false,
            text: this.$t('operationFailuer'),
            textStyle: {
              'text-align': 'center'
            },
            btnText: this.$t('refresh'),
            btnOK: () => {
              location.reload()
            }
          })
        })
      })
    },
    pauseVideo () {
      this.$audioMixing.resumeDefaultVolume() // 视频播放暂停后恢复麦克风音量
      this.getGMTTimestamp().then((time) => {
        signalSdk.sendPauseVideoMP4({
          url: this.currentVideoUrl,
          progress_bar: JSON.stringify(this.currentPlayedTime),
          seek_timestamp: JSON.stringify(time)
        }).then(() => {
          if (this.syncVideoTimer) {
            clearInterval(this.syncVideoTimer)
            this.syncVideoTimer = null
          }
          this.videoStatus = '2'
        }).catch((e) => {
          this.$toast.show({
            header: false,
            text: this.$t('operationFailuer'),
            textStyle: {
              'text-align': 'center'
            },
            btnText: this.$t('refresh'),
            btnOK: () => {
              location.reload()
            }
          })
        })
      })
    },
    endVideo () {
      this.$audioMixing.resumeDefaultVolume() // 视频播放结束恢复麦克风音量
    },
    timerSeekVideo () {
      this.getGMTTimestamp().then((time) => {
        signalSdk.sendSeekVideoMP4({
          url: this.currentVideoUrl,
          status: this.videoStatus,
          progress_bar: JSON.stringify(this.currentPlayedTime),
          seek_timestamp: JSON.stringify(time)
        })
      })
    },
    // 与学生端同步视频进度
    syncVideo () {
      if (this.syncVideoTimer) {
        clearInterval(this.syncVideoTimer)
        this.syncVideoTimer = null
      }
      this.syncVideoTimer = setInterval(() => {
        console.log(this.$refs.baseVideo)
        this.timerSeekVideo()
      }, 10000)
    },
    error (e) {
      let errorCode = e.target.error.code
      switch (errorCode) {
        case 1:
          // 手动取消播放请求
          break
        case 2:
          this.$toast.show({
            header: false,
            text: this.$t('downloadFailure'),
            textStyle: {
              'text-align': 'center'
            },
            btnText: this.$t('refresh'),
            btnOK () {
              location.reload()
            }
          })
          break
        case 3:
        case 4: {
          this.$toast.show({
            header: false,
            text: this.$t('videoError'),
            textStyle: {
              'text-align': 'center'
            },
            btnOK: () => {
              this.$store.commit(types.SET_VIDEO_URL, '')
              this.$store.commit(types.SET_VIDEO_STATUS, 1)
            }
          })
          break
        }
      }
    },
    // 视频挂载完成触发事件用于判断是否需要进行混音
    initMixVideo () {
      this.$eventSource.emit('VIDEO_MOUNTED', this.$refs.baseVideo.$el)
    },
    _close () {
      signalSdk.sendCloseVideoMP4().then(() => {
        this.currentTime = 0
        this.currentPlayedTime = 0
        this.videoStatus = '0'
        this.$store.commit(types.SET_VIDEO_URL, '')
        this.$store.commit(types.SET_VIDEO_STATUS, 1)
        this.$eventSource.emit('RESUME_STREAM') // 关闭视频成功后触发恢复混音事件
      }).catch((e) => {
        // 发送关闭失败
        console.log(e)
      })
    },
    _timeupdate (e) {
      this.currentPlayedTime = e.target.currentTime
    },
    async getGMTTimestamp () {
      let res
      try {
        res = await axios.getServerTime()
      } catch (e) {
        try {
          res = await axios.getServerTime()
        } catch (e) {
          return parseInt(performance.timeOrigin + performance.now())
        }
      }
      return res.nowtime
    }
  },
  destroyed () {
    console.log('destroyed')
    if (this.syncVideoTimer) {
      clearInterval(this.syncVideoTimer)
      this.syncVideoTimer = null
    }
  },
  components: {
    BaseVideo
  }
}
</script>
